import AboutSection from "../../component/modules/aboutSection/AboutSection";
import AppHeader from "../../component/modules/appHeader/AppHeader";
import Footer from "../../component/modules/footer/Footer";
import HeroSection from "../../component/modules/heroSection/HeroSection";
import TechnologyWeUseSection from "../../component/modules/technologyWeUseSection/TechnologyWeUseSection";
import { TECHNOLOGY_WE_USE_SECTION } from "../../utility/utilityData";
import "./index.css";

const About = () => {
  return (
    <div className="about_page_container">
      <AppHeader />
      <div className="about_content_container">
        <HeroSection
          headingpart1="About"
          headingpart2="Us"
          description=" Discover how we've helped businesses across various industries achieve their digital transformation goals."
        />
        <AboutSection />
        <TechnologyWeUseSection
          technologyWeUseSection={TECHNOLOGY_WE_USE_SECTION}
          style={{
            backgroundColor: "#fbfafa",
          }}
        />
      </div>
      <Footer />
    </div>
  );
};

export default About;
